import Vue from 'vue';
import Router from 'vue-router';

import verifyRouteHasAccess from '@/auth/middleware';

Vue.use(Router);

const routes = [
  ...require('@/auth/routes').default,
  ...require('@/dashboard/routes').default,
  ...require('@/clients/routes').default,
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(verifyRouteHasAccess);

export default router;
